module.exports = __webpack_public_path__ + "img/19.6575ae85.png";